import React from 'react';
import { PB_EXCHSNGE_GUIDE } from '../../constants';

function Block4() {
    return (
        <div className="block block_4" style={{ minHeight: '350px' }}>
            <div className="container">
                注意事項:
                <ol style={{ paddingLeft: '0px' }}>
                    <li>2016VIP已於2017/08/31結束，2017/09/01起之VIP資格取得方式及回饋，均依新制VIP規範為準。</li>
                    <li>
                        於遊戲酒吧2017VIP活動贈獎取得之Pub點數，皆有使用期限，
                        請於點數有效期限前兌換至遊戲內
                        <a href={PB_EXCHSNGE_GUIDE} style={{ color: '#00a0e9' }} target="_blank">《轉點教學》</a>，
                        兌換入遊戲之遊戲幣使用時間不在此限。
                        且，活動贈獎取得之點數限會員本人使用，不可與他人進行現金與虛擬物品之買賣交易，
                        並不可要求兌現或改換其他商品。
                    </li>
                    <li>
                        本活動辦法及相關注意事項均載明於本活動網頁中，
                        於參加本活動之同時，即視為已詳閱並同意接受本活動辦法及相關注意事項之規範，
                        如有違反者，主辦單位保留法律追訴權。
                        本活動辦法若有未盡事宜，主辦單位保留增訂、變更、刪除或終止活動內容之權利，
                        修改訊息將公布於遊戲酒吧網站，不另行個別通知，請留意網站公告。
                        如遇不可抗力事由需變更回饋或贈獎內容，主辦單位有權變更為等值獎項，不得求兌現或轉換其他商品。
                    </li>
                </ol>
            </div>
        </div>
    );
}

export default Block4;


// WEBPACK FOOTER //
// ./src/containers/home/block4.jsx